import { FC, MouseEvent, ChangeEvent, useState } from 'react'

import { CheckboxProps } from '@UI/crypto_exchange/desktop/components/controls/Checkbox/types'
import cn from 'clsx'
import c from './Checkbox.module.scss'

export const Checkbox: FC<CheckboxProps> = ({
  name,
  register = () => ({}),
  label,
  required = null,
  error = null,
  onChange,
  disabled = false,
  checked,
  hasError,
  errorMessage,
  onClick,
}) => {
  const [value, setValue] = useState(false)

  const handleClick = (e: MouseEvent<HTMLInputElement>) => {
    onClick?.()
    const target = e.target as HTMLInputElement
    const isChecked = target.checked

    if (onChange) {
      onChange(isChecked)
      setValue(target.checked)
    }
  }

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked

    if (onChange) {
      onChange(isChecked)
    }
  }

  return (
    <>
      <input
        id={name}
        name={name}
        type="checkbox"
        className={`${c.checkbox} ${hasError || error ? c.error : ''}`}
        onClick={handleClick}
        onChange={handleChange}
        value={value}
        disabled={disabled}
        {...register(name, {
          required: required,
        })}
        checked={checked}
      />

      <label className={cn(c.checkboxLabel, label && c.margin)} htmlFor={name}>
        <span className={c.labelText}>{label}</span>
      </label>
      {/*{error && <span className={c.helpError}>{error.message as string}</span>}*/}
    </>
  )
}
